import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadEventAddPage,
  unloadEventAddPage,
  logEvent
} from "../../redux/actions/asset.actions";
import ListErrors from "../../components/ListErrors";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import * as Yup from "yup";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

const EventSchema = Yup.object().shape({
  asset: Yup.string().required(i18n.t("event.form_asset_required_error")),
  site: Yup.string().required(i18n.t("event.form_site_required_error"))
});

// A custom hook that builds on useLocation to parse
// the query string for you.
// https://reacttraining.com/react-router/web/example/query-parameters
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
export default function() {
  const query = useQuery();
  const from = query.get("from");
  const assetkey = query.get("assetkey");
  const sitekey = query.get("sitekey");
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadEventAddPage());
    return () => dispatch(unloadEventAddPage());
  }, [assetkey, sitekey]);

  const handleSubmit = (asset, site, type, value, longitude, latitude) => {
    if (type === "location") {
      value = { longitude, latitude };
    }
    let key = from === "asset" ? assetkey : sitekey;
    dispatch(logEvent(asset, site, type, value, from, key));
  };

  if (!asset.sites || !asset.assets) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"events"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"events"} />
          <div id="content">
            <Header />
            <div className="content-wrap content-narrow">
              <div className="box-header">
                <Link className="header-button" to={`/events`}>
                  {t("common.back")}
                </Link>
                <h2> {t("event.create_title")}</h2>
              </div>
              <Formik
                initialValues={{
                  site: sitekey,
                  asset: assetkey,
                  type: "temperature",
                  value: "",
                  longitude: "",
                  latitude: ""
                }}
                validationSchema={EventSchema}
                onSubmit={(payload, { setSubmitting }) => {
                  handleSubmit(
                    payload.asset,
                    payload.site,
                    payload.type,
                    payload.value,
                    payload.longitude,
                    payload.latitude
                  );
                  setSubmitting(false);
                }}
              >
                {({ values, isSubmitting }) => (
                  <Form>
                    <div className={`form-item`}>
                      <label htmlFor="site"> {t("common.site")}</label>
                      <Field as="select" name="site">
                        <option key={""} value={""}>
                          {t("common.option_select_site")}
                        </option>
                        {asset.sites.map(item => {
                          return (
                            <option key={item.key} value={item.key}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="site"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="asset">{t("common.asset")}</label>
                      <Field as="select" name="asset">
                        <option key={""} value={""}>
                          {t("common.option_select_asset")}
                        </option>
                        {asset.assets
                          .filter(x => x.site === values.site)
                          .map(item => {
                            return (
                              <option key={item.key} value={item.key}>
                                {item.name}
                              </option>
                            );
                          })}
                      </Field>
                      <ErrorMessage
                        name="asset"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    <div className={`form-item`}>
                      <label htmlFor="type">{t("common.type")}</label>
                      <Field as="select" name="type">
                        <option value={"temperature"}>
                          {t("common.temperature")}
                        </option>
                        <option value={"location"}>
                          {t("common.location")}
                        </option>
                      </Field>
                      <ErrorMessage
                        name="type"
                        className="error-message"
                        component="div"
                      />
                    </div>
                    {values.type === "temperature" ? (
                      <div className={`form-item`}>
                        <label htmlFor="value">{t("common.value")}</label>
                        <Field name="value" placeholder="" />
                      </div>
                    ) : (
                      <>
                        <div className={`form-item`}>
                          <label htmlFor="longitude">
                            {t("common.longitude")}
                          </label>
                          <Field
                            name="longitude"
                            type="text"
                            placeholder="10.001122"
                          />
                        </div>
                        <div className={`form-item`}>
                          <label htmlFor="latitude">
                            {t("common.latitude")}
                          </label>
                          <Field
                            name="latitude"
                            type="text"
                            placeholder="10.001122"
                          />
                        </div>
                      </>
                    )}

                    <ListErrors errors={asset.errors} />
                    <div className="form-item">
                      <button type="submit" disabled={isSubmitting}>
                        {isSubmitting
                          ? t("system.submitting_feeback")
                          : t("event.create_button")}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}
